var path = 'scripts/views/components/receipt-card-input.html';
var html = "<div class=\"scrollable-dropdown-menu\">\n    <input\n            class=\"form-control modal-cardmember-names\"\n            id=\"cardmember-dropdown\"\n            ng-model=\"$ctrl.displayedCardName\"\n            uib-typeahead=\"card.displayName for card in $ctrl.cardList | filter:{displayName:$viewValue}\"\n            typeahead-min-length=\"0\"\n            typeahead-on-select=\"$ctrl.onCardChanged({card: $item})\">\n    </input>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/receipt-card-input.html
// module id = 336
// module chunks = 0